import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { base_url } from '../../constants'
import img404 from '../../assets/img/404.jpg'
import 'animate.css'

export const Redireccionar = () => {
  const [redirecciona, setRedirecciona] = useState(false)

  useEffect(() => {
    const timerId = setTimeout(() => setRedirecciona(true), 3000)
    return () => clearTimeout(timerId)
  }, [])
  if (!redirecciona) {
    return (
      <div className="container-fluid bg-main animate__animated animate__wobble">
        <br />
        <img src={img404} width="40%" alt="not_found"></img>
      </div>
    )
  } else {
    return <Navigate to={{ pathname: `/${base_url}/` }} replace />
  }
}
